import { migrate, Puck } from "@measured/puck";
import React, { useEffect } from "react";
import Cookies from 'js-cookie';
import {config}  from './EditorConfig';

import { TwAlert, Text, Button, Dialog, Icon } from '@ui-component-library';
import "@measured/puck/puck.css";
import tailwindCSS from "../../../styles/tailwind.css";

const IframeStyleInjector = ({ children, document: iframeDoc }) => {
    useEffect(() => {
        if (!iframeDoc) return;
        if (iframeDoc.querySelector('style[data-tailwind="puck-iframe"]')) return;
        const style = iframeDoc.createElement('style');
        style.setAttribute('data-tailwind', 'puck-iframe');
        style.textContent = tailwindCSS;
        iframeDoc.head.appendChild(style);
        return () => { style.remove(); };
    }, [iframeDoc]);
    return <>{children}</>;
};

const startContentPage = {
    content: [
        {
            type: "Navigation",
            props: {
                id: "Navigation-d64392d3-ae72-400a-8b3f-f08940947809"
            }
        },
        {
            type: "Footer",
            props: {
                id: "Footer-d568d06f-fcd6-4927-9188-ab47f15b8400"
            }
        }
    ],
    root: {},
    zones: {}
}

const startContentPost = {
    content: [
        {
            type: "Navigation",
            props: {
                id: "Navigation-d64392d3-ae72-400a-8b3f-f08940947809"
            }
        },
        {
            type: "PostCommon",
            props: {
                id: "PostCommon-d6das2d3-ae72-400a-8b3f-f08978947809"
            }
        },
        {
            type: "Footer",
            props: {
                id: "Footer-d568d06f-fcd6-4927-9188-ab47f15b8400"
            }
        }
    ],
    root: {},
    zones: {}
}

const ALERT_AUTO_HIDE_MS = 5000;

const getMigratedData = (data)=>{
    if (data && data.zones){
        return migrate(data, config)
    }
    return data;
}


const getInitialEditorData = () => {
    let data = Window.react_data;

    // Prioritize draft, then live content, otherwise start from scratch
    if (data.draft) {
        return getMigratedData(data.draft);
    } else if (data.content) {
        return getMigratedData(data.content);
    } else {
        // If no draft or live content, return the default structure based on type
        if (data.edit_obj_type === "page") {
            return startContentPage;
        } else if (data.edit_obj_type === "post") {
            return startContentPost;
        } else {
            // Fallback for unexpected cases
            return {
                content: [],
                root: {},
                zones: {}
            };
        }
    }
}

class Editor extends React.Component{
    constructor(props){
        super(props)
        this.state={
            alert: false,
            alertKey: 0,
            content: getInitialEditorData(),
            draft: Window.react_data.draft,
            live: Window.react_data.content,
            refresh: false,
            updateEditingByIsRunning: false,
            choicesModal: Window.react_data.draft || Window.react_data.content ? true : false
        }

        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.saveDraftTimer = null;
        this.alertHideTimeout = null;
    }

    clearAlertHideTimeout() {
        if (this.alertHideTimeout) {
            clearTimeout(this.alertHideTimeout);
            this.alertHideTimeout = null;
        }
    }

    scheduleAlertHide() {
        this.clearAlertHideTimeout();
        this.alertHideTimeout = setTimeout(() => {
            this.alertHideTimeout = null;
            this.setState((prev) => ({
                alert: false,
                alertKey: prev.alertKey + 1
            }));
        }, ALERT_AUTO_HIDE_MS);
    }

    updateEditingBy() {
        this.setState({updateEditingByIsRunning: true})
        setTimeout(() => {
            const headers = {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken')
            }
            // API request to update last edited by
            return fetch(`/admin-api/${Window.react_data.edit_obj_type}/${Window.react_data.id}/`, {
                method: 'PATCH',
                headers: headers,
                body: JSON.stringify({})
            }).then(() => {
                this.updateEditingBy()
            })
        }, 60000);
    }

    componentDidMount() {
        if(!this.state.updateEditingByIsRunning) {
            this.updateEditingBy()
        }
        document.addEventListener('keydown', this.handleKeyDown);
        
    }

    startTimer=()=>{
        if (this.saveDraftTimer){
            clearInterval(this.saveDraftTimer);
        }
        this.saveDraftTimer = setInterval(()=>{this.save(null,true)}, 5 * 60 * 1000);
    }

    refreshPuck() {
        this.setState({ refresh: true })

        setTimeout(() => {
            this.setState({ refresh: false })
        }, 50);
    }

    save(content, draft){
        const headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': Cookies.get('csrftoken')
        }
        let data = {}
        if(draft){
            data = {
                draft: this.state.content
            }
        } else{
            data = {
                draft: false,
                content: this.state.content,
                is_live: true
            }

        }
        
        return fetch(`/admin-api/${Window.react_data.edit_obj_type}/${Window.react_data.id}/`, {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(data)
        }).then(() => {
            if(draft){
                this.setState((prev) => ({
                    draft: prev.content,
                    alert: true,
                    alertKey: prev.alertKey + 1,
                    alertContent: { title: "Success!", text: `Successfully saved draft for ${Window.react_data.title}!` }
                }))
            } else {
                this.setState((prev) => ({
                    draft: null,
                    live: prev.content,
                    alert: true,
                    alertKey: prev.alertKey + 1,
                    alertContent: { title: "Congratulations!", text: `${Window.react_data.title} has been published live!` }
                }))
            }
            this.scheduleAlertHide();
            this.startTimer()
        })
    }

    overrides(){
        return {
        iframe: IframeStyleInjector,
        headerActions: ({ children }) => (
            <>
                {children}
                <button className='_Button_1brfa_1 _Button--secondary_1brfa_53 _Button--medium_1brfa_22' onClick={() => window.open('/vb-admin/cms/', '_self')}>CMS</button>
                {this.state.live ? <button className='_Button_1brfa_1 _Button--secondary_1brfa_53 _Button--medium_1brfa_22' onClick={() => window.open("/" +Window.react_data.url, '_blank')}>Preview live</button>: null}
                {this.state.draft ? <button className='_Button_1brfa_1 _Button--secondary_1brfa_53 _Button--medium_1brfa_22' onClick={() => window.open("/" +Window.react_data.url+'draft/', '_blank')}>Preview draft</button>: null}
                <button className='_Button_1brfa_1 _Button--secondary_1brfa_53 _Button--medium_1brfa_22' onClick={() => {this.save(null, true)}}>Save draft</button>
            </>
        ),}
    }

    handleKeyDown(event) {
        if (event.ctrlKey || event.metaKey) { 
          if (event.key === 's') {
            event.preventDefault();
            this.save(null,true);
          }
        }
      }
    
      componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
        if (this.saveDraftTimer) {
            clearInterval(this.saveDraftTimer); 
        }
        this.clearAlertHideTimeout();
      }

    render(){
        return <div onKeyDown={this.handleKeyDown}>
            {!this.state.refresh ? <Puck 
                headerPath={Window.react_data.url}
                headerTitle={Window.react_data.title}
                config={config} 
                data={this.state.content} 
                onPublish={() => {this.setState({publishModal: true})}} 
                onChange={(content) => {this.setState({content: content})}} 
                overrides={this.overrides()} />: null}

            <TwAlert key={this.state.alertKey} className="text-center mx-[3rem] my-2 bg-success-500" icon="CheckOutlined" visible={!!this.state.alert} allowClose onClose={() => { this.clearAlertHideTimeout(); this.setState({ alert: false }); }}>
                <Text variant="text-xl/leading-none/medium" className="text-white">{this.state.alertContent?.title}</Text>
                <Text variant="text-xl/leading-none/medium" className="mb-0 text-white">{this.state.alertContent?.text}</Text>
            </TwAlert>

            <Dialog isOpen={false} size="small" className="bg-primary-dark">
                <Dialog.Header>
                    <Text variant="text-xl/leading-none/medium">Choices</Text>
                </Dialog.Header>
                <Dialog.Content>
                    {this.state.draft && <Text variant="text-xl/leading-none/medium" >Last edited by: {Window.react_data.editing_by_name} - {Window.react_data.last_edited ? Window.react_data.last_edited.slice(0, 10) : 'undefined'}</Text>}
                    <Text variant="text-xl/leading-none/medium">This pages seems to already have live content and/or draft content. How would you like to proceed?</Text>
                </Dialog.Content>
                <Dialog.Footer>
                    <div className="flex justify-between">
                        {!Window.react_data.draft ? <button type="button" className="n-btn btn-sm" onClick={() => {this.setState({ content: Window.react_data.edit_obj_type == "page" ? startContentPage : startContentPost, choicesModal: false }); this.refreshPuck(); this.startTimer(); }}>FROM SCRATCH</button> : null}
                        {Window.react_data.content && !Window.react_data.draft ? <button type="button" className="n-btn btn-sm" onClick={() => {this.setState({ content: getMigratedData(Window.react_data.content), choicesModal: false }); this.refreshPuck(); this.startTimer(); }}>NEW DRAFT FROM LIVE</button> : null}
                        {Window.react_data.draft ? <button type="button" className="n-btn btn-sm" onClick={() => {this.setState({ content: getMigratedData(Window.react_data.draft), choicesModal: false }); this.refreshPuck(); this.startTimer(); }}>CONTINUE DRAFT</button> : null}
                    </div>
                </Dialog.Footer>
            </Dialog>

            <Dialog isOpen={this.state.publishModal}>
                <Dialog.Header>
                    <Text variant="text-xl/leading-none/medium">Publish {Window.react_data.title} live?</Text>
                    <Button variant="tertiary" size="icon" onClick={() => this.setState({publishModal: false})}>
                        <Icon name="CrossSimple" className="color-charcoal-500" size="large" />
                    </Button>
                 
                </Dialog.Header>
                <Dialog.Content>
                    <Text variant="text-xl/leading-none/medium">Are you sure you want to publish this page live?</Text>
                </Dialog.Content>
                <Dialog.Footer>
                    <div className="flex justify-between">
                        <Button variant= "secondary" onClick={() => this.setState({ publishModal: false })}>CANCEL</Button>
                        <Button variant= "primary" onClick={() => {this.setState({ publishModal: false }); this.save(this.state.content, false)}}>PUBLISH</Button>        
                    </div>
                </Dialog.Footer>
            </Dialog>
        </div>;
    }
}

// Render Puck editor
export default Editor